// ======================================================================
// File Name       : GroupUserAdminContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Row, Col, Table, Button } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { RETURN_MAX_NUM, RETURN_MAX_NUM_1000 } from '../../constants';
import MessageSearch from '../../components/MessageSearch';
import MessageView from '../../components/MessageView';
import GroupUserAdminList from '../../components/group/GroupUserAdminList';
import GroupUserAdminEditList from '../../components/group/GroupUserAdminEditList';
import * as MessageTemplate from '../../constants/MessageTemplate';
import CustomButton from '../../components/button/CustomButton';
import { MESSAGE_TYPE } from '../../constants/index';

class GroupUserAdminContainer extends Component {
  constructor() {
    super();
    this.state = {
      checkedUser: [],
      checkedUserOnPage: [],
      isAllowShowSearchMessage: false,
      isInit: false,
    };
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleSearchConditionChange = this.handleSearchConditionChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleUserCheck = this.handleUserCheck.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleAddBtn = this.handleAddBtn.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
  }

  componentDidMount() {
    const { group } = this.props;
    !group.searchResultAdmin.searched && this.handleSearchBtn();
  }

  handleNextBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleSearchConditionChange({ target }) {
    const { dispatch } = this.props;
    const { name, value } = target;
    dispatch(groupActions.editingAdminSearchCondition({ [name]: value }));
  }

  handleSearchBtn() {
    const { dispatch, group } = this.props;
    this.setState({ checkedUserOnPage: [], isAllowShowSearchMessage: false, isInit: false }, () => {
      dispatch(
        groupActions.searchUserAdmin({
          ...group.searchConditionAdmin,
          startPosition: 0,
          returnMaxNum: RETURN_MAX_NUM,
        }),
      ).then(() => {
        if (!this.state.isInit) {
          this.setState({ isAllowShowSearchMessage: true });
        }
      });
    });
  }

  handlePageChange(startPosition) {
    this.setState({ checkedUserOnPage: [] });
    const { dispatch, group } = this.props;
    dispatch(
      groupActions.searchUserAdmin({
        ...group.searchConditionAdmin,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      }),
    );
  }

  handleUserCheck(event) {
    const { value } = event.target;
    const checkedUser = [...this.state.checkedUser];
    const checkedUserOnPage = [...this.state.checkedUserOnPage];
    const pos = checkedUser.indexOf(value);
    pos < 0 ? checkedUser.unshift(value) : checkedUser.splice(pos, 1);
    const pos2 = checkedUserOnPage.indexOf(value);
    pos2 < 0 ? checkedUserOnPage.unshift(value) : checkedUserOnPage.splice(pos2, 1);
    this.setState({ checkedUser, checkedUserOnPage });
  }

  handleCheckAll() {
    const { group } = this.props;
    const searchResultAdmin = group.searchResultAdmin.allSecernIds.reduce((acc, cur) => {
      if (!group.editingUserGroupAdmin[cur]) {
        acc.push(cur);
      }
      return acc;
    }, []);

    const { checkedUserOnPage, checkedUser } = this.state;
    if (this.state.checkedUserOnPage.length === searchResultAdmin.length) {
      // uncheckAll
      checkedUserOnPage.map((userSecernId) => {
        const pos = checkedUserOnPage.indexOf(userSecernId);
        if (checkedUser.indexOf(userSecernId) > -1) {
          checkedUser.splice(pos, 1);
        }
        return null;
      });
      this.setState({ checkedUserOnPage: [], checkedUser });
      return;
    }
    // checkAll
    searchResultAdmin.map((userSecernId) => {
      if (checkedUser.indexOf(userSecernId) < 0) {
        checkedUser.unshift(userSecernId);
      }
      return null;
    });
    this.setState({ checkedUserOnPage: [...searchResultAdmin], checkedUser });
  }

  handleAddBtn() {
    const { dispatch } = this.props;
    this.scrollToBottom();
    dispatch(groupActions.editingUserAdmin({ addedList: this.state.checkedUser }));
  }

  handleRemoveUser(userSecernId) {
    const { dispatch } = this.props;
    const { checkedUser, checkedUserOnPage } = this.state;
    const pos = checkedUser.indexOf(userSecernId);
    if (pos >= 0) {
      checkedUser.splice(pos, 1);
    }
    const pos2 = checkedUserOnPage.indexOf(userSecernId);
    if (pos2 >= 0) {
      checkedUserOnPage.splice(pos2, 1);
    }
    this.setState({
      checkedUser,
      checkedUserOnPage,
    }, () => {
      dispatch(groupActions.editingUserAdmin({ removedSecern: userSecernId }));
    });
  }

  handleRemoveAll() {
    const { dispatch } = this.props;
    this.setState({
      checkedUser: [],
      checkedUserOnPage: [],
    }, () => {
      dispatch(groupActions.editingUserAdmin({ removedAll: true }));
    });
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-admin');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  getModalOptions() {
    return {
      title: 'ユーザーグループに所属する管理ユーザーを選択してください',
      footerBtns: null,
    };
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const { group, authority } = this.props;
    const { editingUserGroupAdmin, searchConditionAdmin, searchResultAdmin, recordNumUserInGroup } = group;
    const { managementAuthorityList } = authority;
    const authorityBySecern = authority.bySecernId;
    let displayAuthorityList = [];
    if(managementAuthorityList && managementAuthorityList.length){
      displayAuthorityList.push({});
      displayAuthorityList = displayAuthorityList.concat(managementAuthorityList);
    }
    const messageInformation = { // step 11.0.1 TBD
      messageVisible: true,
      messageType: MESSAGE_TYPE.info,
      messageHeader: '',
      messageContent: [MessageTemplate.MSG_INFORMATION_GROUP],
      dismissible: false,
    }
    return (
      <ModalWrapper {...this.getModalOptions()} dialogClassName="group-dialog" hideModal={this.props.hideModal}>
        <div className="max-width-950">
          <MessageSearch
            recordNum={searchResultAdmin ? searchResultAdmin.recordNum : 0}
            resultList={searchResultAdmin ? searchResultAdmin.allSecernIds : []}
            isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
            dismissMessage={this.dismissMessage}
          />
          {/* Step 11.0.1 TBD START */}
          <MessageView message={messageInformation}/>
          {/* Step 11.0.1 TBD END */}
          <Form className='form-horizontal' onSubmit={(e) => { e.preventDefault();}}>
            <Form.Group className="row form-info">
              <Col as={Form.Label} sm={3}>ユーザー名</Col>
              <Col sm={9}>
                <FormControl
                  name="userName"
                  value={searchConditionAdmin.userName || ''}
                  onChange={this.handleSearchConditionChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="row form-info">
              <Col as={Form.Label} sm={3}>
                ログインID
              </Col>
              <Col sm={9}>
                <FormControl
                  name="loginId"
                  value={searchConditionAdmin.loginId || ''}
                  onChange={this.handleSearchConditionChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="row form-info">
              <Col as={Form.Label} sm={3}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <SelectBox
                  name="userAttributeKeyNum"
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                  value={searchConditionAdmin.userAttributeKeyNum}
                  onChange={this.handleSearchConditionChange}
                />
              </Col>
              <Col sm={7} className="padding-left-15">
                <FormControl
                  name="userAttributeSearchText"
                  value={searchConditionAdmin.userAttributeSearchText || ''}
                  onChange={this.handleSearchConditionChange}
                />
              </Col>
            </Form.Group>
            <Row>
              <Col sm={12} className="text-center padding-top-10">
                {/* <Button bsStyle="primary" className="btn-96" onClick={this.handleSearchBtn}>
                  search
                </Button> */}
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  handleClick={this.handleSearchBtn}
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Row>
          </Form>
          <GroupUserAdminList
            searchResultAdmin={searchResultAdmin}
            editingUserGroupAdmin={editingUserGroupAdmin}
            authorityBySecern={authorityBySecern}
            checkedUserOnPage={this.state.checkedUserOnPage}
            handleCheckAll={this.handleCheckAll}
            handlePageChange={this.handlePageChange}
            handleUserCheck={this.handleUserCheck.bind(this)}
            handleAddBtn={this.handleAddBtn}
          />
          <GroupUserAdminEditList
            authorityBySecern={authorityBySecern}
            editingUserGroupAdmin={editingUserGroupAdmin}
            handleRemoveUser={this.handleRemoveUser}
            handleRemoveAll={this.handleRemoveAll}
            handleBackBtn={this.handleBackBtn}
            handleNextBtn={this.handleNextBtn}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(GroupUserAdminContainer);
